import React from 'react';
import { Show, DateField, TextField } from 'react-admin';
import { AmountField, LinkField } from '../../components/fields';
import { Grid, GridShowLayout } from '../../components/wrapper';
import PaymentFailureShowActions from './PaymentFailureShowActions';

const PaymentFailureShow = props => (
	<Show {...props} actions={<PaymentFailureShowActions />}>
		<GridShowLayout>
			<Grid container>
				<Grid item xs>
					<TextField source="id" />
					<TextField source="description" />
					<DateField source="creationDateTime" showTime />
					<DateField source="expiryDateTime" showTime />
					<TextField source="externalReferenceId" />
					<TextField source="paymentFailureType" />
					<TextField source="paymentFailureStatus" />
				</Grid>
				<Grid item xs>
					<TextField source="customType" />
					<AmountField source="amount" />
					<AmountField source="feeAmount" />
					<LinkField source="walletId" type="Wallet" />
					<LinkField source="walletAccountId" type="WalletAccount" />
					<LinkField
						source="walletAccountItemId"
						type="WalletAccountItem"
					/>
					<LinkField source="paymentId" type="Payment" />
				</Grid>
			</Grid>
		</GridShowLayout>
	</Show>
);

export default PaymentFailureShow;
